var _defs, _path, _line, _line2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew209({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.5,14.39a7.5,7.5,0,0,1,15,0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8,
    y1: 3.84,
    x2: 8,
    y2: 6.83
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.5,
    y1: 6.25,
    x2: 9.54,
    y2: 12.21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.19,6.3V5.91l.49-.47C11.86,4.32,12.39,3.72,12.4,3a.82.82,0,0,0-.92-.9,1.57,1.57,0,0,0-1,.39l-.2-.44a2,2,0,0,1,1.31-.47A1.3,1.3,0,0,1,13,3c0,.85-.62,1.54-1.59,2.47l-.37.35h2.07V6.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew209);
export default __webpack_public_path__ + "static/media/Symbolpack_New_209.3e46a7b1ac173ed941add603275c1f2a.svg";
export { ForwardRef as ReactComponent };